/* HUSHLY — popup : question, puis email, puis code */
(function(){
  var KEY='hushly_popup_seen', KEYTAB='hushly_popup_tab_off';
  function init(){
    var pop=document.getElementById('hushly-popup');
    if(!pop || pop.dataset.hpopReady==='1') return;
    pop.dataset.hpopReady='1';

    var tab=document.getElementById('hushly-popup-tab');
    function tabShow(){
      if(!tab) return;
      try{ if(localStorage.getItem(KEYTAB)==='1') return; }catch(e){}
      tab.hidden=false; void tab.offsetHeight; tab.classList.add('is-on');
    }
    function tabHide(){ if(tab){ tab.classList.remove('is-on'); setTimeout(function(){tab.hidden=true},300); } }
    if(tab){
      tab.querySelector('[data-hpop-tab-open]').addEventListener('click',function(){ tabHide(); open(); });
      tab.querySelector('[data-hpop-tab-close]').addEventListener('click',function(){
        tabHide(); try{ localStorage.setItem(KEYTAB,'1'); }catch(e){}
      });
    }

    /* deja vu recemment ? on n'ouvre pas tout seul, mais tout reste branche
       pour que l'encoche puisse rouvrir un popup pleinement fonctionnel */
    var days=parseInt(pop.dataset.days||'30',10), once=pop.dataset.once==='true', dejaVu=false;
    try{
      var seen=parseInt(localStorage.getItem(KEY)||'0',10);
      /* en mode une seule fois, il suffit de l'avoir vu une fois pour qu'il ne revienne plus */
      dejaVu = once ? !!seen : !!(seen && (Date.now()-seen) < days*864e5);
    }catch(e){}

    var steps={}, answer=null, url=null, readyT=null, autoT=null, exitHandler=null;

    /* On desarme le declenchement automatique des la premiere ouverture. Sans ca,
       l'ecouteur d'intention de sortie restait branche apres la fermeture : le
       visiteur fermait, remontait la souris vers la barre d'adresse, et le popup
       lui revenait dessus. */
    function stopAuto(){
      clearTimeout(autoT);
      if(exitHandler){ document.removeEventListener('mouseout', exitHandler); exitHandler=null; }
    }
    pop.querySelectorAll('[data-hpop-step]').forEach(function(s){ steps[s.dataset.hpopStep]=s; });

    function show(n){
      Object.keys(steps).forEach(function(k){ steps[k].hidden = k!==String(n); });
      var f=steps[String(n)].querySelector('input,button,a');
      if(f) setTimeout(function(){ try{f.focus()}catch(e){} },60);
    }
    function open(){
      if(!pop.hidden) return;
      stopAuto();
      tabHide();
      pop.hidden=false; void pop.offsetHeight; pop.classList.add('is-on');
      document.body.classList.add('hpop-open');
      /* la croix n'apparait qu'au bout du delai reglé. Echap ferme quand meme, toujours. */
      pop.classList.remove('is-ready');
      var cd=parseInt(pop.dataset.closeDelay||'2',10)*1000;
      clearTimeout(readyT);
      readyT=setTimeout(function(){ pop.classList.add('is-ready'); }, cd);
      try{ localStorage.setItem(KEY, String(Date.now())); }catch(e){}
    }
    function close(){
      clearTimeout(readyT);
      pop.classList.remove('is-on');pop.classList.remove('is-ready');
      document.body.classList.remove('hpop-open');
      setTimeout(function(){ pop.hidden=true; tabShow(); },260);
      try{ localStorage.setItem(KEY, String(Date.now())); }catch(e){}
    }

    pop.querySelectorAll('[data-hpop-close]').forEach(function(b){ b.addEventListener('click',close); });
    addEventListener('keydown',function(e){ if(e.key==='Escape' && !pop.hidden) close(); });

    /* temps 1 : la reponse */
    pop.querySelectorAll('[data-hpop-answer]').forEach(function(b){
      b.addEventListener('click',function(){
        answer=b.dataset.hpopAnswer; url=b.dataset.hpopUrl||'';
        var tags=pop.querySelector('[data-hpop-tags]');
        if(tags) tags.value='newsletter,popup-'+answer;
        var go=pop.querySelector('[data-hpop-go]');
        if(go && url) go.setAttribute('href',url);
        document.dispatchEvent(new CustomEvent('hushly:popup:answer',{detail:{answer:answer}}));
        show(2);
      });
    });

    /* temps 2 : l'email, envoye a Shopify sans quitter la page */
    var form=pop.querySelector('form');
    if(form){
      form.addEventListener('submit',function(e){
        if(!window.fetch) return;                     /* sans fetch on laisse le POST classique */
        e.preventDefault();
        var btn=form.querySelector('button[type=submit]'); var lbl=btn?btn.textContent:'';
        if(btn){ btn.disabled=true; btn.textContent='…'; }
        var err=pop.querySelector('[data-hpop-err]');
        if(err) err.hidden=true;
        var restore=function(){ if(btn){ btn.disabled=false; btn.textContent=lbl; } };

        fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}})
          .then(function(r){
            if(!r.ok) throw new Error('statut '+r.status);
            /* Shopify redirige vers customer_posted=true quand l'inscription passe.
               Sans ce marqueur, elle a ete refusee : on ne donne pas le code a
               quelqu'un dont on n'a pas enregistre l'adresse. */
            if(!r.url || r.url.indexOf('customer_posted=true')===-1) throw new Error('refuse');
            restore(); show(3);
          })
          .catch(function(){
            restore();
            if(err){ err.hidden=false; }
            var f=form.querySelector('input[type=email]');
            if(f){ try{ f.focus(); }catch(e){} }
          });
      });
    }

    /* temps 3 : copier le code */
    var code=pop.querySelector('[data-hpop-code]');
    if(code){
      code.addEventListener('click',function(){
        var txt=code.childNodes[0].textContent.trim();
        var done=function(){ code.classList.add('is-copied');
          var s=code.querySelector('span'); if(s){ var o=s.textContent; s.textContent='copied'; setTimeout(function(){ s.textContent=o; code.classList.remove('is-copied'); },1800); } };
        if(navigator.clipboard) navigator.clipboard.writeText(txt).then(done,done); else done();
      });
    }

    /* ?popup=1 dans l'adresse force l'ouverture immediate, meme s'il a deja ete vu.
       Sert a le controler sans avoir a vider le stockage du navigateur. */
    var force = /[?&]popup=1(?:&|$)/.test(location.search);
    if(force){ open(); return; }

    /* declenchement automatique, seulement si on ne l'a pas deja vu */
    if(dejaVu){ tabShow(); return; }
    var delay=parseInt(pop.dataset.delay||'6',10)*1000;
    autoT=setTimeout(open, delay);
    if(pop.dataset.exit==='true'){
      exitHandler=function(e){
        if(!e.relatedTarget && e.clientY<=0){ open(); }
      };
      document.addEventListener('mouseout', exitHandler);
    }
  }
  if(document.readyState==='loading') addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
